// extracted by mini-css-extract-plugin
module.exports = {"group":"RadioGroup_group__RYNv1","legend":"RadioGroup_legend__1WFag","error":"RadioGroup_error__1FDnb"};